import React from "react";
import { MDBInput, MDBBadge, MDBIcon } from "mdb-react-ui-kit";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import "./UserSearchPicker.css";

/**
 * Buscador combinado de usuarios SSO + usuarios temporales CCON.
 *
 * Props:
 *   usuariosCCON  {Array}    Lista de usuarios CCON precargada (para evitar fetch extra)
 *   onSelect      {Function} Callback cuando se selecciona un usuario: (user) => {}
 *                            user: { tipo: "SSO"|"CCON", IDUsuario?, IDUsuarioCCON?, nombre, apodo?, email? }
 *   excludeIds    {Array}    IDs de usuarios SSO ya añadidos (para no sugería duplicados)
 *   excludeCCONIds{Array}    IDs de usuarios CCON ya añadidos
 */
class UserSearchPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: "",
      resultadosSSO: [],
      loading: false,
    };
    this._debounce = null;
  }

  handleQueryChange(e) {
    const query = e.target.value;
    this.setState({ query });

    clearTimeout(this._debounce);
    if (query.trim().length < 2) {
      this.setState({ resultadosSSO: [] });
      return;
    }
    this._debounce = setTimeout(() => this.buscarSSO(query), 300);
  }

  buscarSSO(query) {
    this.setState({ loading: true });
    doFetch("SSO", `searchUsers?query=${encodeURIComponent(query)}`, null)
      .then((r) => r.json())
      .then((data) => {
        this.setState({ resultadosSSO: data.DATA || [] });
      })
      .catch(() => this.setState({ resultadosSSO: [] }))
      .finally(() => this.setState({ loading: false }));
  }

  seleccionar(user) {
    this.setState({ query: "", resultadosSSO: [] });
    this.props.onSelect(user);
  }

  render() {
    const { query, resultadosSSO, loading } = this.state;
    const { usuariosCCON = [], excludeIds = [], excludeCCONIds = [] } = this.props;

    const filteredSSO = resultadosSSO.filter(
      (u) => !excludeIds.includes(u.IDUsuario)
    );
    const filteredCCON = usuariosCCON.filter(
      (u) =>
        !excludeCCONIds.includes(u.IDUsuarioCCON) &&
        (u.nombre.toLowerCase().includes(query.toLowerCase()) ||
          (u.email || "").toLowerCase().includes(query.toLowerCase()))
    );

    const hayResultados = filteredSSO.length > 0 || filteredCCON.length > 0;

    return (
      <div className="user-search-picker">
        <div className="user-search-input-wrap">
          <MDBInput
            label="Buscar usuario..."
            value={query}
            onChange={(e) => this.handleQueryChange(e)}
          />
          {loading && (
            <MDBIcon icon="spinner" spin className="user-search-spinner" />
          )}
        </div>
        {query.trim().length >= 2 && (
          <div className="user-search-dropdown">
            {!hayResultados && !loading && (
              <div className="user-search-empty">Sin resultados</div>
            )}
            {filteredSSO.map((u) => (
              <div
                key={`sso-${u.IDUsuario}`}
                className="user-search-item"
                onClick={() =>
                  this.seleccionar({
                    tipo: "SSO",
                    IDUsuario: u.IDUsuario,
                    nombre: u.apodo || u.nombre,
                    apodo: u.apodo,
                  })
                }
              >
                <MDBBadge color="primary" pill light className="me-2">
                  SSO
                </MDBBadge>
                {u.apodo || u.nombre}
              </div>
            ))}
            {filteredCCON.map((u) => (
              <div
                key={`ccon-${u.IDUsuarioCCON}`}
                className="user-search-item"
                onClick={() =>
                  this.seleccionar({
                    tipo: "CCON",
                    IDUsuarioCCON: u.IDUsuarioCCON,
                    nombre: u.nombre,
                    email: u.email,
                  })
                }
              >
                <MDBBadge color="secondary" pill light className="me-2">
                  Ext
                </MDBBadge>
                {u.nombre}
                {u.email && (
                  <span className="user-search-email"> ({u.email})</span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default UserSearchPicker;
